/**
 * Typed access to client build-time configuration. Vite exposes variables
 * prefixed with `VITE_` on `import.meta.env`. Centralising access here keeps
 * `import.meta.env` out of the rest of the codebase and gives one place to add
 * validation as configuration grows.
 */
export const env = {
  /** API base path. Empty string means "same origin" (the default, since the
   *  server serves the client and the dev server proxies /api). */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

/** The beta badge and home-page beta line show unless the build sets
 *  `VITE_OPSHUB_BETA=false` (the launch switch). Read at call time so a test
 *  can stub the variable. */
export function isBeta(): boolean {
  return import.meta.env.VITE_OPSHUB_BETA !== "false";
}
